import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/mailing/groups',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
  ],
};